var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseTemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 15.9997V6.85561H15.6673V6.17827L8.00065 0.420898L0.333984 6.17827V6.85561H2.00065V15.9997",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 13.968C6.03486 13.968 6.33333 13.6647 6.33333 13.2906C6.33333 12.9165 6.03486 12.6133 5.66667 12.6133C5.29848 12.6133 5 12.9165 5 13.2906C5 13.6647 5.29848 13.968 5.66667 13.968Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 6.5166V12.6126",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 5.84198C7.00065 5.4827 6.86017 5.13813 6.61013 4.88408C6.36008 4.63003 6.02094 4.4873 5.66732 4.4873C5.3137 4.4873 4.97456 4.63003 4.72451 4.88408C4.47446 5.13813 4.33398 5.4827 4.33398 5.84198V11.3454C3.92632 11.6338 3.61989 12.0468 3.45929 12.5244C3.29869 13.002 3.29231 13.5192 3.44106 14.0008C3.58982 14.4823 3.88595 14.9031 4.28636 15.2018C4.68677 15.5005 5.17056 15.6615 5.66732 15.6615C6.16407 15.6615 6.64786 15.5005 7.04827 15.2018C7.44868 14.9031 7.74482 14.4823 7.89357 14.0008C8.04233 13.5192 8.03594 13.002 7.87534 12.5244C7.71474 12.0468 7.40831 11.6338 7.00065 11.3454V5.84198Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00065 9.56464C9.36884 9.56464 9.66732 9.26138 9.66732 8.8873C9.66732 8.51322 9.36884 8.20996 9.00065 8.20996C8.63246 8.20996 8.33398 8.51322 8.33398 8.8873C8.33398 9.26138 8.63246 9.56464 9.00065 9.56464Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.5836C12.6667 10.7632 12.5964 10.9355 12.4714 11.0625C12.3464 11.1896 12.1768 11.2609 12 11.2609H11.6667C11.4899 11.2609 11.3203 11.1896 11.1953 11.0625C11.0702 10.9355 11 10.7632 11 10.5836V8.89023C11 8.71059 11.0702 8.5383 11.1953 8.41128C11.3203 8.28425 11.4899 8.21289 11.6667 8.21289H12C12.1768 8.21289 12.3464 8.28425 12.4714 8.41128C12.5964 8.5383 12.6667 8.71059 12.6667 8.89023",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseTemp);
export default __webpack_public_path__ + "static/media/houseTemp.61c284a7.svg";
export { ForwardRef as ReactComponent };